export default __webpack_public_path__ + "static/media/collect-trade-icon.993d6b27.png";